const DEFAULT_LDU_AFFECTED_STATES = ["RI", "KY", "IN"];
let configuredAffectedStates = new Set(DEFAULT_LDU_AFFECTED_STATES);
function configureLDUStates(states) {
  if (states && states.length > 0) {
    configuredAffectedStates = new Set(states.map((s) => s.toUpperCase().trim()));
  } else {
    configuredAffectedStates = new Set(DEFAULT_LDU_AFFECTED_STATES);
  }
}
function getConfiguredStates() {
  return Array.from(configuredAffectedStates);
}
function isAffectedState(stateCode) {
  if (!stateCode) return false;
  return configuredAffectedStates.has(stateCode.toUpperCase().trim());
}
function shouldApplyLDU(shippingState, billingState) {
  return isAffectedState(shippingState) || isAffectedState(billingState);
}
function getLDUOptions(shippingState, billingState) {
  if (!shouldApplyLDU(shippingState, billingState)) {
    return null;
  }
  return {
    enabled: true,
    country: 1,
    // 1 = United States
    state: 0
    // 0 = auto-detect state based on IP (Meta will verify)
  };
}
export {
  configureLDUStates,
  getConfiguredStates,
  getLDUOptions,
  isAffectedState,
  shouldApplyLDU
};
//# sourceMappingURL=limitedDataUse.js.map
